import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";

const ButtonAdd = (props) => {
  const { children, ...attribute } = props;
  return (
    <Button color="success" {...attribute}>
      <FontAwesome fa="plus" /> {children}
    </Button>
  );
};

ButtonAdd.propTypes = {
  children: PropTypes.any,
};

ButtonAdd.defaultProps = {};

export default ButtonAdd;
